import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import Home from './views/Home.vue'
import Projects from './views/Projects.vue'
import Copyright from './views/Copyright.vue'
import Deploy from './views/Deploy.vue'
import About from './views/About.vue'
import Member from './views/Member.vue'
import Profile from './views/Profile.vue'
import Beginner from './views/Beginner.vue'
import AgentGuide from './views/AgentGuide.vue'
import './styles.css'

const routes = [
  { path: '/', component: Home, meta: { title: '尔数创研｜让好想法真正上线', description: '软著申请、项目源码与部署服务。' } },
  { path: '/beginner', component: Beginner, meta: { title: '零基础专区｜尔数创研', description: '从第一行代码开始，借助 AI 完成你的第一个可运行项目。' } },
  { path: '/agent-guide', component: AgentGuide, meta: { title: 'AI Agent 工具指南｜尔数创研', description: '五款主流 AI 编程 Agent 的优缺点、注意事项与入门教程。' } },
  { path: '/copyright', component: Copyright, meta: { title: '软件著作权申请｜尔数创研', description: '软件著作权材料整理与申请服务。' } },
  { path: '/projects', component: Projects, meta: { title: '项目中心｜尔数创研', description: '精选项目源码与技术实战项目。' } },
  { path: '/deploy', component: Deploy, meta: { title: '项目部署服务｜尔数创研', description: '从环境配置到上线验收的项目部署服务。' } },
  { path: '/about', component: About, meta: { title: '关于我们｜尔数创研', description: '认识尔数创研产品技术团队。' } },
  { path: '/member', component: Member, meta: { title: '会员中心｜尔数创研', description: '月度、季度、年度和终身会员方案。' } },
  { path: '/profile', component: Profile, meta: { title: '个人中心｜尔数创研', description: '管理个人资料与会员信息。', auth: true } }
]
const router = createRouter({ history: createWebHistory(), routes, scrollBehavior: () => ({ top: 0 }) })
router.beforeEach(to => {
  if (to.meta.auth && !localStorage.getItem('token')) return '/'
})
router.afterEach(to => { document.title = to.meta.title; document.querySelector('meta[name="description"]').content = to.meta.description })
createApp(App).use(router).mount('#app')
